export class Permission {
    public Name: string;
    public Type: PermissionTypes;
    public FullAccess: string;
    public LeastAccess: string;
    //public Permissions: Permission[];
    public ApiUrl: string;

    constructor(name: string, type: PermissionTypes, fullAccess:string = null, leastAccess:string = null/*, permissions: Permission[] = [], apiUrl = null*/) {
        this.Name = name;
        this.Type = type;
        this.FullAccess = fullAccess;
        this.LeastAccess = leastAccess;
        //this.Permissions = permissions;
        //this.ApiUrl = apiUrl;
    };
};

export class DynamicPermission {
    public Name: string;
    public Type: PermissionTypes;
    public ValueKey: string;
    public TextKey: string;

    constructor(name: string, type: PermissionTypes, valueKey: string = 'Id', textKey: string = 'Name') {
        this.Name = name;
        this.Type = type;
        this.ValueKey = valueKey;
        this.TextKey = textKey;
    };
};

export class PermissionName {
    public Name: string;

    constructor(name: string) {
        this.Name = name;
    }

    public toString = (): string => {
        return this.Name;
    }
};

export enum PermissionTypes {
    Read = 0,
    ReadWrite = 1,
    ReadWriteDelete = 2,
    Boolean = 3,
    Text = 4,
};

export enum AccessTypes {
    Read = 1,
    Write = 2,
    Delete = 3
};

export class PermissionBankItem {
    public Permission: Permission;
    public AccessTypes: AccessTypes[];
    public AccessValue: string;

    constructor(permission: Permission, accessTypes: AccessTypes[] = null, acessValue:string = null) {
        this.Permission = permission;
        this.AccessTypes = accessTypes;
        this.AccessValue = acessValue;
    };
};
